import type { Maybe } from '@adornis/base/utilTypes.js';
import { showDialog } from '@adornis/dialog/dialog-functions.js';
import { html } from 'lit';
import type { UserListSelectionInterface } from '../entities/UserListSelectionInterface.js';
import { UserList } from './UserList.js';

export async function openUserListSelectionDialog(actionName: string) {
  return showDialog<Maybe<UserListSelectionInterface>>({
    content: (resolve, reject) => html`
      <div class="h-[50vh] max-h-[50vh]">
        ${UserList({ userSelection: { actionName, resolveUserSelection: resolve, rejectUserSelection: reject } })}
      </div>
    `,

    modalBoxClasses: 'w-[95vw] h-[95vh] max-w-[95vw] max-h-[95vh] overflow-hidden',
  });
}
